import { Box, Typography } from "@mui/material";
import React from "react";
import background from "../../../Utils/Images/background.png";
import left from "../../../Utils/Images/Round Arrow Left.svg";
import CustomInput from "../../../Components/input/CustomInput";
import CustomButton from "../../../Components/Button/CustomButton";
import { Link } from "react-router-dom";
const Login = () => {
  return (
    <>
      <Box
        sx={{
          height: "100vh",
          objectFit: "cover",
          fill: "Background",
          backgroundImage: `url(${background})`,
          backgroundSize: "cover",
          backgroundPosition: "cover",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: { xs: "70%", sm: "60%", md: "40%", xl: "25%" },
            padding: { xs: "20px", md: "35px", xl: "45px" },
            borderRadius: "10px",
            bgcolor: "#F3F3F3",
            m: "auto",
            boxShadow: "10px 10px 26px 0px #0000001A",
          }}
        >
          <Box sx={{ textAlign: "left", mb: "20px" }}>
            <Link to={"/login"}>
              <img src={left} alt="back arrow" />
            </Link>
          </Box>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontSize: { xs: "20px", md: "22px", xl: "25px" },
              fontWeight: "600",
              lineHeight: "25px",
              textAlign: "left",
            }}
          >
            Forgot Password 👋🏼
          </Typography>
          <Box
            sx={{
              width: "273px",
              textAlign: "left",
              mt: 2,
            }}
          >
            <Typography
              sx={{
                fontFamily: "inter",
                fontSize: { xs: "14px", md: "15px", xl: "16px" },
                fontWeight: "400",
                lineHeight: "22.4px",
                textAlign: "left",
                color: "#737373",
              }}
            >
              Enter Your Email to <br />
              Get Reset Password Link
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              mt: "10px",
            }}
          >
            <CustomInput
              variant="outlined"
              // onChange={handleEmail}
              placeholder="Email Address"
              sx={{
                mt: "5px",
                textAlign: "center",
                bgcolor: "white",
                borderRadius: "5px",
                fontSize: { xs: "8px", md: "10px", xl: "34px" },
              }}
            />
          </Box>

          <CustomButton
            // disabled={loading}
            sx={{
              mt: "20px",
              height: { xs: "25px", md: "40px", xl: "60px" },
            }}
            // onClick={handleLogin}
          >
            Reset
          </CustomButton>
        </Box>
      </Box>
    </>
  );
};

export default Login;
